import { Dispatch, SetStateAction, useMemo } from 'react';
import {
  DataTable,
  TableSkeleton,
  Pagination,
  PaginationState,
} from '@/components';
import { EmptyState } from './components';
import { createProvidersColumns } from './columns';
import { PatientProviderSummary } from './types';

interface ProvidersTableProps {
  providers: PatientProviderSummary[];
  totalCount: number;
  isLoading: boolean;
  pagination: PaginationState;
  onPaginationChange: Dispatch<SetStateAction<PaginationState>>;
}

export const ProvidersTable = ({
  providers,
  totalCount,
  isLoading,
  pagination,
  onPaginationChange,
}: ProvidersTableProps) => {
  const columns = useMemo(() => createProvidersColumns(), []);

  if (isLoading) {
    return (
      <div className="min-w-0 flex-1">
        <TableSkeleton rows={5} columns={columns.length} />
      </div>
    );
  }

  if (providers.length === 0) {
    return (
      <div className="min-w-0 flex-1">
        <EmptyState />
      </div>
    );
  }

  return (
    <div className="min-w-0 flex-1">
      <DataTable columns={columns} data={providers} />
      <Pagination
        pagination={pagination}
        setPagination={onPaginationChange}
        totalCount={totalCount}
        pageSizeOptions={[10, 20, 50]}
      />
    </div>
  );
};
